angular.module('SpidApp')

.factory('OrderItemSyncService',
        ['$http', 'SyncConfig','Chunker','$q',
function ($http,   SyncConfig,Chunker,$q) {
  var nodeUrl = SyncConfig.Node.getURLFor('/orderItems')
  var nodeAuthorization = SyncConfig.Node.Authorization

  var distantUrl = SyncConfig.Distant.getURLFor('/orderItems')
  var distantAuthorization = SyncConfig.Distant.Authorization

  var OrderItemSyncService = {
    Node: {
      getAllUnsync: function (lastSyncIsoDate) {
        if (!lastSyncIsoDate) {
          throw 'OrderItemSyncService::Node::getAllUnsync() - Missing parameters'
        }

        var req = { method: 'GET', url: nodeUrl, headers: { 'Authorization': nodeAuthorization } }
        
        return $http(req).then(function (response) {
          return response.data
        }).then(function (transactions) {
          var filteredTransactions = _.filter(transactions, function (transaction) {
            return moment(transaction.updated_at).isAfter(moment(lastSyncIsoDate), 'second') // TODO
          })
          return filteredTransactions
        })
      },
      pushAll: function (elems) {
        var chunked = Chunker.inConstantSizeChunks(elems, SyncConfig.config.chunkLength)
        var p = $q(function (r) {r()})
        
        var pools = []
        for(var i = 0 ; i < chunked.length ; i++) {
          var data = chunked[i]
          var req = { method: 'POST', url: nodeUrl, headers: { 'Authorization': nodeAuthorization }, data: data }
          pools.push($http(req))
        }
        
        return p.then(function () {
          return $q.all(pools)
        }).then(function () {
          return {order_item: 'OK'}
        })
      }
    },
    Distant: {
      pushAll: function (transactions) {
          var chunked = Chunker.inConstantSizeChunks(transactions, SyncConfig.config.chunkLength)
          var p = $q(function (r) {r()})

          var pool = []
          for(var i = 0 ; i < chunked.length ; i++) {
              var data = chunked[i]
              var req = { method: 'POST', url: distantUrl, headers: { 'Authorization': distantAuthorization }, data: data }
              pool.push($http(req))
          }

          return p.then(function () {
              return $q.all(pool)
          }).then(function () {
              return {generic: 'OK'}
          })
      },
      getAllUnsync: function () {
        var req = { method: 'GET', url: distantUrl, headers: { 'Authorization': distantAuthorization } }

        return $http(req).then(function (response) {
          return response.data
        })
      }
    }
  }

  return OrderItemSyncService
}])